<template>
    <HamletTable
        :columns="columns"
        :fetch="fetch"
        @onRowClick="onRowClick"
        @created="onTableCreated"
    >
        <template #header-label>
            {{ $t('Component(GeneralProductStatement):label') }}
        </template>

        <template #header-controls>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-0 btn-icon"
                v-if="$can('visit', 'administration-product-general-product-statements-add')"
                @click="addUser"
            >
                <feather-icon icon="PlusIcon" />
            </b-button>
        </template>
    </HamletTable>
</template>

<script>
import {
    BCard, BButton, BCol
} from 'bootstrap-vue'
import HamletTable from "@core/components/common/HamletTable";
import {ProductApi, UserApi} from "@core/api";
import Ripple from 'vue-ripple-directive'

export default {
    components: {
        BCard, BCol, BButton,
        HamletTable,
    },
    directives: {Ripple},
    data() {
        return {
            statements: [],
            fetchCallback: null,
            config: null,
            showLoader: false,
            columns: [
                {
                    key: 'organizationStatement',
                    label: this.$t('Component(Grid):column-organization-statement')
                },
                {
                    key: 'productStatement',
                    label: this.$t('Component(Grid):column-product-statement')
                },
                {
                    key: 'exemptionMessage',
                    label: this.$t('Component(Grid):column-exemption-message')
                },
            ],
        };
    },
    methods: {
        onRowClick(user) {
            if (this.$can('visit', 'administration-product-general-product-statements-edit')) {
                this.$router.push({
                    name: 'administration-product-general-product-statements-edit',
                    params: {
                        id: user.id
                    }
                });
            }
        },
        addUser() {
            this.$router.push({name: 'administration-product-general-product-statements-add'});
        },
        fetch(config, cb) {
            const start = (config.page - 1) * config.perPage;
            cb(
                this.statements.length,
                this.statements.slice(start, start + config.perPage)
            );
        },
        onTableCreated(config, cb, showLoader) {
            this.config = config;
            this.fetchCallback = cb;
            this.showLoader = showLoader;
        },
    },

    created() {
        ProductApi.getGeneralProductStatements([], {}, 1, 15).then(r => {
            this.statements = r.data;
            if (this.config) {
                this.fetch(this.config, this.fetchCallback);
            }
        });
    }
}
</script>
